import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { computed } from 'vue';
import type { PayTerminalPrice } from '@/types';
import { Currency } from '@/types';

const DEFAULT_TERMINALS = [
  {
    id: 1,
    name: 'AMS1',
    key: 'AMS1',
    price: 19900,
    info: ['touchscreen', 'without_print', 'easily_portable'],
    printer: false,
    touchscreen: true,
    wifi: true,
    portable: true,
    '4g': true,
  },
  {
    id: 2,
    name: 'S1F2',
    key: 'S1F2',
    price: 39900,
    info: ['touchscreen', 'without_print', 'easily_portable', 'receipt'],
    printer: true,
    touchscreen: true,
    wifi: true,
    portable: true,
    '4g': true,
  },
];

const GET_PAY_TERMINAL_PRICES = gql`
  query getPayTerminalPrices {
    payTerminalPrices {
      currency
      error
      price
      type
    }
  }
`;

export const useTerminalData = () => {
  const { result, loading } = useQuery(
    GET_PAY_TERMINAL_PRICES,
    {},
    {
      fetchPolicy: 'cache-first',
    },
  );

  const terminals = computed(() => {
    const apiData = result.value?.payTerminalPrices || [];

    return DEFAULT_TERMINALS.map((terminal) => {
      const apiTerminal = apiData.find(
        (t: PayTerminalPrice) => t.type === terminal.key,
      );

      return {
        ...terminal,
        currency: (apiTerminal?.currency as Currency) || Currency.Eur,
        price: apiTerminal?.price ?? terminal.price,
      };
    });
  });

  return {
    terminals,
    loading,
  };
};
